/**
 * HeaderItem.js
 */

import React, {useState, useEffect, useMemo, useCallback} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import Utility from '../../../../util/utilityfunctions';
import EllipseControl from '../../EllipsesControl/EllipsesControl';
import SectionList from '../Section/SectionList';
import {getConfiguration} from '../HeaderSectionDisplayConfiguration';
import {objectComparator} from '../../../../util/utils';

function HeaderItem({header, documentTypeId, taskId, source, onShowDrawerChanges, selectedDocumentsCount}) {
	const snapshotCompareDetails = useSelector((store) => store.snapshotCompareDetails);

	const [targetHeader, setTargetHeader] = useState({});

	useEffect(() => {
		if (snapshotCompareDetails?.length > 0) {
			setTargetHeader(snapshotCompareDetails?.find((c) => c.id === header?.id));
		}
	}, [header?.id, snapshotCompareDetails]);

	const config = useMemo(() => getConfiguration(source), [source]);


	const getExtraProps = () => {
		if (config?.snapshot) {
			return {
				targetHeader
			};
		}

		return {};
	};

	const snapshotLabelRender = () => {
		if (config && config.render) {
			return config.render(targetHeader);
		}
	};

	return (
		<StyledHeaderItem className="StyledHeaderItem">
			<h2 className="FormTitleHeader">
				<EllipseControl
					content={Utility.getHtmlTextElement(header?.formHeaderName ?? header?.name)}
					id={header?.id}
					tooltip={Utility.getHtmlTextElement(header?.formHeaderName ?? header?.name)}
					displayId={''}
					noOfLines={1}
				/>
				{snapshotLabelRender()}
			</h2>
			<SectionList
				sections={header?.sections?.filter((s) => s.isDisplayed === true && s.isSummary === false)}
				headerId={header?.id}
				documentTypeId={documentTypeId}
				taskId={taskId}
				source={source}
				onShowDrawerChanges={onShowDrawerChanges}
				selectedDocumentsCount={selectedDocumentsCount}
				{...getExtraProps()}
			/>
		</StyledHeaderItem>
	);
}

export default HeaderItem;

const StyledHeaderItem = styled.section`
	.FormTitleHeader {
		margin: 0;
		padding: var(--px-16) var(--px-24);
		display: flex;
		.ellipses {
			div {
				font-size: var(--px-16);
				color: var(--neutrals-900);
				font-weight: 400;
				line-height: var(--px-24);
			}
		}
	}
`;
